<template>
    <div class="thankyou">
        <div class="thankyou__header">
          <div class="thankyou__visual">
              <SvgIcon class="thankyou__check--icon" type="check_icon_green" />
          </div>
          <div class="thankyou__text">
              <div class="thankyou__title">
                  {{ $t('thankYou:title') }}
              </div>
              <div class="thankyou__lead--text">
                  {{ $t('thankYou:description') }}
              </div>
          </div>
        </div>
        <template v-if="result >= 5000">
          <carousel :per-page="1" :perPageCustom="[[768, 1], [1024, 3]]" :navigationEnabled="true">
              <slide>
                  <Tile>
                      <template #header>
                        {{ $t('thankYou:payWorldwide.title') }}
                      </template>
                      <div slot="content" v-html="$t('thankYou:payWorldwide.info')"/>
                      <template #footer>
                        <div class="btn-panel">
                            <a :href="$t('thankYou:payWorldwide.moreInfo.link.url')"  class="btn btn-white" target='_blank'>
                                {{ $t('thankYou:payWorldwide.moreInfo.link.title') }}
                            </a>
                            <button
                              class="btn btn-carbon"
                              @click="openContactForm = !openContactForm"
                              @keyup="openContactForm = !openContactForm"
                              >
                              {{ $t('thankYou:payWorldwide.label') }}
                            </button>
                        </div>
                    </template>
                  </Tile>
              </slide>
              <slide>
                  <Tile>
                      <template #header>
                        {{ $t('thankYou:paymentTracking.title') }}
                      </template>
                      <div slot="content" v-html="$t('thankYou:paymentTracking.info')"/>
                      <template #footer>
                        <div class="btn-panel">
                            <a :href="$t('thankYou:paymentTracking.moreInfo.link.url')" class="btn btn-white" target='_blank'>
                                {{ $t('thankYou:paymentTracking.moreInfo.link.title') }}
                            </a>
                            <button
                                class="btn btn-carbon"
                                @click="openContactForm = !openContactForm"
                                @keyup="openContactForm = !openContactForm"
                                >
                              {{ $t('thankYou:paymentTracking.label') }}
                            </button>
                        </div>
                    </template>
                  </Tile>
              </slide>
              <slide>
                  <Tile>
                      <template #header>
                        {{ $t('thankYou:marketInformation.title') }}
                      </template>
                      <div slot="content" v-html="$t('thankYou:marketInformation.info')"/>
                  </Tile>
              </slide>
          </carousel>
          <Modal
              name="contact-us"
              class="modal-layout-override contact-us-modal personal-info"
              :open="openContactForm"
              @close="openContactForm = false"
              >
              <template #header>
                  <span class="personal-info__heading">{{
                  $t("contactUs:clientInformation.heading")
                  }}</span>
              </template>
              <template #content>
                  <ContactUs @close="openContactForm = false"/>
              </template>
          </Modal>
        </template>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import Tile from '@/components/layout/Tile'
import { Carousel, Slide } from 'vue-carousel'
import Modal from '@/components/layout/Modal'
import ContactUs from '@/views/Contact-Us'
import { mapGetters } from 'vuex'

export default {
    name: 'ThankYou',
    data() {
        return {
            openContactForm: false
        }
    },
    components: {
        SvgIcon,
        Tile,
        Carousel,
        Slide,
        Modal,
        ContactUs
    },
    computed: {
        ...mapGetters('question', [
            'result'
        ])
    },
    mounted() {
        document.querySelector('.thankyou').scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
}
</script>
